import { render } from "./SectionDescription.vue?vue&type=template&id=63702d64"
import script from "./SectionDescription.vue?vue&type=script&lang=js"
export * from "./SectionDescription.vue?vue&type=script&lang=js"
script.render = render

export default script